import PropTypes from 'prop-types'

import Text from 'components/common/Text'
import theme from 'theme'

export default function TitleWithIcon({
  icon: IconComponent,
  label,
  textStyle,
  iconStyle,
  as,
  className,
  ...rest
}) {
  return (
    <div
      className={className}
      css={{
        alignItems: 'center',
        display: 'grid',
        gap: theme.space[2],
        gridTemplateColumns: 'min-content auto'
      }}
    >
      <IconComponent
        css={{
          fontSize: theme.fontSizes[2],
          color: theme.colors.steel[1],
          ...iconStyle
        }}
      />
      <Text overflowEllipsis as={as} color="medium" css={textStyle} {...rest}>
        {label}
      </Text>
    </div>
  )
}

TitleWithIcon.propTypes = {
  icon: PropTypes.oneOfType([PropTypes.object, PropTypes.func]),
  label: PropTypes.string,
  iconStyle: PropTypes.object,
  textStyle: PropTypes.object,
  as: PropTypes.string,
  className: PropTypes.string
}

TitleWithIcon.defaultProps = {
  as: 'h4'
}
